module.exports = __webpack_public_path__ + "media/images/home/Banner_ad_acceleratorcon-bbe35d96b37d23466de5fb6b35c88115.png";